import React from 'react'

export function TwitterIcon(props) {


    return (
        <>

            <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24 2.36764C23.1182 2.76923 22.1687 3.04081 21.1727 3.16215C22.1898 2.5381 22.9702 1.54857 23.3379 0.369808C22.3856 0.947635 21.3333 1.368 20.2092 1.59335C19.3133 0.612495 18.0328 0 16.6156 0C13.8982 0 11.6936 2.26074 11.6936 5.04875C11.6936 5.44457 11.7359 5.82882 11.8204 6.19863C7.72812 5.98772 4.10072 3.97978 1.67072 0.921633C1.2467 1.66992 1.0044 2.5381 1.0044 3.46262C1.0044 5.21343 1.87357 6.75912 3.19493 7.66486C2.38915 7.6403 1.62846 7.41062 0.96355 7.03503V7.09715C0.96355 9.54424 2.66103 11.5854 4.91495 12.0477C4.5022 12.1661 4.06691 12.2254 3.61754 12.2254C3.30058 12.2254 2.99067 12.195 2.69061 12.1358C3.31749 14.1408 5.13471 15.6013 7.29002 15.6403C5.60521 16.9953 3.48089 17.8028 1.17485 17.8028C0.777601 17.8028 0.384575 17.7797 0 17.7335C2.17926 19.1636 4.76845 20 7.54781 20C16.6057 20 21.5573 12.3077 21.5573 5.63525C21.5573 5.41567 21.5531 5.1961 21.5446 4.98086C22.5068 4.26869 23.3421 3.38028 24 2.36764Z" fill="#0A142F" />
            </svg>
        </>
    )
}
